
import React from 'react';
import { render } from 'react-dom';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Scroll from 'react-scroll';
import MichaelImage from '../images/MichaelImage.png';
import Button from "react-bootstrap/Button";

import CommentOutline from '../images/CommentOutline.png';
import SaraImage from '../images/SaraImage.png';
import TylerImage from '../images/TylerImage.png';
import MichelleImage from '../images/MichelleImage.png';
import DennisImage from '../images/DennisImage.png';
var Element = Scroll.Element;
var Events = Scroll.Events;
var scroll = Scroll.animateScroll;
var scrollSpy = Scroll.scrollSpy;
class Members extends React.Component {
    constructor(props) {
        super(props);
        this.scrollToTop = this.scrollToTop.bind(this);
    }
    componentDidMount() {
        Events.scrollEvent.register('begin', function () {
            console.log("begin", arguments);
        });
        Events.scrollEvent.register('end', function () {
            console.log("end", arguments);
        });
        scrollSpy.update();
    }
    scrollToTop() {
        scroll.scrollToTop();
    }
    componentWillUnmount() {
        Events.scrollEvent.remove('begin');
        Events.scrollEvent.remove('end');
    }
    render() {
        return (
            <div>
                <nav className="navbar navbar-default navbar-fixed-top">
                    <div className="container-fluid">
                        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                            <ul className="nav navbar-nav">
                                <li>

                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
                <Element name="test7" className="element" id="containerElement" style={{
                    position: 'relative',
                    height: '350px',
                    overflow: 'scroll',
                    marginBottom: '10px',
                    paddingLeft: '20px',
                    paddingRight: '20px'
                }}>
                    <Element name="firstInsideContainer" style={{
                        marginBottom: '10px',
                        paddingLeft: '20px',
                        paddingRight: '20px'
                    }}>
                        <Row>
                            <Col>
                                <img src={MichaelImage} style={{ width: '', height: '', borderRadius: '50%' }} alt="" />
                            </Col>
                            <Col >
                                <Row>
                                    <span style={{
                                        fontFamily: 'Sintony',
                                        fontSize: '11px',
                                        fontWeight: '400',
                                        lineHeight: '18.24px',
                                        color: '#475666',
                                    }}>
                                        Michael L.
                                        Denver, CO
                                    </span>
                                </Row>
                                <Row>
                                    <span style={{
                                        fontSize: '11px',
                                        color: '#3786C3'
                                    }}>
                                        Joined: 09/28/20
                                    </span>
                                </Row>
                            </Col>
                            <Col>
                                <Button variant="outline-secondary" size="lg" type="submit" style={{
                                    height: '43px',
                                    width: '100px',
                                    fontSize: '12px',
                                    borderRadius: '0',
                                    color: '#979797',
                                    borderColor: '#979797',
                                }} >
                                    <img src={CommentOutline} style={{ width: '19px', height: '17px' }} alt="" />   CHAT
                                </Button>
                            </Col>
                        </Row>
                    </Element>
                    <hr></hr>
                    <Element id="same" className="element" style={{
                        marginBottom: '5px',
                        paddingLeft: '20px',
                        paddingRight: '20px'
                    }}>
                        <Row>
                            <Col>
                                <img src={DennisImage} style={{ width: '', height: '', borderRadius: '50%' }} alt="" />
                            </Col>
                            <Col >
                                <Row>
                                    <span style={{
                                        fontFamily: 'Sintony',
                                        fontSize: '11px',
                                        fontWeight: '400',
                                        lineHeight: '18.24px',
                                        color: '#475666',
                                    }}>
                                        Dennis J.
                                        Chicago, IL
                                    </span>
                                </Row>
                                <Row>
                                    <span style={{
                                        fontSize: '11px',
                                        color: '#3786C3'
                                    }}>
                                        Joined: 09/28/20
                                    </span>
                                </Row>
                            </Col>
                            <Col>
                                <Button variant="outline-secondary" size="lg" type="submit" style={{
                                    height: '43px',
                                    width: '100px',
                                    fontSize: '12px',
                                    borderRadius: '0',
                                    color: '#979797',
                                    borderColor: '#979797',
                                }} >
                                    <img src={CommentOutline} style={{ width: '19px', height: '17px' }} alt="" />   CHAT
                                </Button>
                            </Col>
                        </Row>
                    </Element>
                    <hr></hr>
                    <Element name="secondInsideContainer" style={{
                        marginBottom: '5px',
                        paddingLeft: '20px',
                        paddingRight: '20px'
                    }}>
                        <Row>
                            <Col>
                                <img src={SaraImage} style={{ width: '', height: '', borderRadius: '50%' }} alt="" />
                            </Col>
                            <Col >
                                <Row>
                                    <span style={{
                                        fontFamily: 'Sintony',
                                        fontSize: '11px',
                                        fontWeight: '400',
                                        lineHeight: '18.24px',
                                        color: '#475666',
                                    }}>
                                        Sara M.
                                        Burlington, VT
                                    </span>
                                </Row>
                                <Row>
                                    <span style={{
                                        fontSize: '11px',
                                        color: '#3786C3'
                                    }}>
                                        Joined: 09/28/20
                                    </span>
                                </Row>
                            </Col>
                            <Col>
                                <Button variant="outline-secondary" size="lg" type="submit" style={{
                                    height: '43px',
                                    width: '100px',
                                    fontSize: '12px',
                                    borderRadius: '0',
                                    color: '#979797',
                                    borderColor: '#979797',
                                }} >
                                    <img src={CommentOutline} style={{ width: '19px', height: '17px' }} alt="" />   CHAT
                                </Button>
                            </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                            <Col>
                                <img src={TylerImage} style={{ width: '', height: '', borderRadius: '50%' }} alt="" />
                            </Col>
                            <Col >
                                <Row>
                                    <span style={{
                                        fontFamily: 'Sintony',
                                        fontSize: '11px',
                                        fontWeight: '400',
                                        lineHeight: '18.24px',
                                        color: '#475666',
                                    }}>
                                        Tyler K.
                                        Boise, ID
                                    </span>
                                </Row>
                                <Row>
                                    <span style={{
                                        fontSize: '11px',
                                        color: '#3786C3'
                                    }}>
                                        Joined: 09/28/20
                                    </span>
                                </Row>
                            </Col>
                            <Col>
                                <Button variant="outline-secondary" size="lg" type="submit" style={{
                                    height: '43px',
                                    width: '100px',
                                    fontSize: '12px',
                                    borderRadius: '0',
                                    color: '#979797',
                                    borderColor: '#979797',
                                }} >
                                    <img src={CommentOutline} style={{ width: '19px', height: '17px' }} alt="" />   CHAT
                                </Button>
                            </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                            <Col>
                                <img src={MichelleImage} style={{ width: '', height: '', borderRadius: '50%' }} alt="" />
                            </Col>
                            <Col>
                                <Row>
                                    <span style={{
                                        fontFamily: 'Sintony',
                                        fontSize: '11px',
                                        fontWeight: '400',
                                        lineHeight: '18.24px',
                                        color: '#475666',
                                    }}>
                                        Michelle D.
                                        Chicago, IL
                                    </span>
                                </Row>
                                <Row>
                                    <span style={{
                                        fontSize: '11px',
                                        color: '#3786C3'
                                    }}>
                                        Joined: 09/28/20
                                    </span>
                                </Row>
                            </Col>
                            <Col>
                                <Button variant="outline-secondary" size="lg" type="submit" style={{
                                    height: '43px',
                                    width: '100px',
                                    fontSize: '12px',
                                    borderRadius: '0',
                                    color: '#979797',
                                    borderColor: '#979797',
                                }} >
                                    <img src={CommentOutline} style={{ width: '19px', height: '17px' }} alt="" />   CHAT
                                </Button>
                            </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                            <Col>
                                <img src={DennisImage} style={{ width: '', height: '', borderRadius: '50%' }} alt="" />
                            </Col>
                            <Col >
                                <Row>
                                    <span style={{
                                        fontFamily: 'Sintony',
                                        fontSize: '11px',
                                        fontWeight: '400',
                                        lineHeight: '18.24px',
                                        color: '#475666',
                                    }}>
                                        Dennis J.
                                        Chicago, IL
                                    </span>
                                </Row>
                                <Row>
                                    <span style={{
                                        fontSize: '11px',
                                        color: '#3786C3'
                                    }}>
                                        Joined: 09/28/20
                                    </span>
                                </Row>
                            </Col>
                            <Col>
                                <Button variant="outline-secondary" size="lg" type="submit" style={{
                                    height: '43px',
                                    width: '100px',
                                    fontSize: '12px',
                                    borderRadius: '0',
                                    color: '#979797',
                                    borderColor: '#979797',
                                }} >
                                    <img src={CommentOutline} style={{ width: '19px', height: '17px' }} alt="" />   CHAT
                                </Button>
                            </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                            <Col>
                                <img src={DennisImage} style={{ width: '', height: '', borderRadius: '50%' }} alt="" />
                            </Col>
                            <Col >
                                <Row>
                                    <span style={{
                                        fontFamily: 'Sintony',
                                        fontSize: '11px',
                                        fontWeight: '400',
                                        lineHeight: '18.24px',
                                        color: '#475666',
                                    }}>
                                        Dennis J.
                                        Chicago, IL
                                    </span>
                                </Row>
                                <Row>

                                    <span style={{
                                        fontSize: '11px',
                                        color: '#3786C3'
                                    }}>
                                        Joined: 09/28/20
                                    </span>
                                </Row>
                            </Col>
                            <Col>
                                <Button variant="outline-secondary" size="lg" type="submit" style={{
                                    height: '43px',
                                    width: '100px',
                                    fontSize: '12px',
                                    borderRadius: '0',
                                    color: '#979797',
                                    borderColor: '#979797',
                                }} >
                                    <img src={CommentOutline} style={{ width: '19px', height: '17px' }} alt="" />   CHAT
                                </Button>
                            </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                            <Col>
                                <img src={DennisImage} style={{ width: '', height: '', borderRadius: '50%' }} alt="" />
                            </Col>
                            <Col >
                                <Row>
                                    <span style={{
                                        fontFamily: 'Sintony',
                                        fontSize: '11px',
                                        fontWeight: '400',
                                        lineHeight: '18.24px',
                                        color: '#475666',
                                    }}>
                                        Dennis J.
                                        Chicago, IL
                                    </span>
                                </Row>
                                <Row>
                                    <span style={{
                                        fontSize: '11px',
                                        color: '#3786C3'
                                    }}>
                                        Joined: 09/28/20
                                    </span>
                                </Row>
                            </Col>
                            <Col>
                                <Button variant="outline-secondary" size="lg" type="submit" style={{
                                    height: '43px',
                                    width: '100px',
                                    fontSize: '12px',
                                    borderRadius: '0',
                                    color: '#979797',
                                    borderColor: '#979797',
                                }} >
                                    <img src={CommentOutline} style={{ width: '19px', height: '17px' }} alt="" />   CHAT
                                </Button>
                            </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                            <Col>
                                <img src={DennisImage} style={{ width: '', height: '', borderRadius: '50%' }} alt="" />
                            </Col>
                            <Col >
                                <Row>
                                    <span style={{
                                        fontFamily: 'Sintony',
                                        fontSize: '11px',
                                        fontWeight: '400',
                                        lineHeight: '18.24px',
                                        color: '#475666',
                                    }}>
                                        Dennis J.
                                        Chicago, IL
                                    </span>
                                </Row>
                                <Row>
                                    <span style={{
                                        fontSize: '11px',
                                        color: '#3786C3'
                                    }}>
                                        Joined: 09/28/20
                                    </span>
                                </Row>
                            </Col>
                            <Col>
                                <Button variant="outline-secondary" size="lg" type="submit" style={{
                                    height: '43px',
                                    width: '100px',
                                    fontSize: '12px',
                                    borderRadius: '0',
                                    color: '#979797',
                                    borderColor: '#979797',
                                }} >
                                    <img src={CommentOutline} style={{ width: '19px', height: '17px' }} alt="" />   CHAT
                                </Button>
                            </Col>
                        </Row>
                    </Element>
                </Element>





                {/* <a onClick={this.scrollToTop}>To the top!</a> */}

            </div>
        );
    }
};

export default Members;
render(<Members />, document.getElementById('root'));
